import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const DebitCardAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/solusi-keseharian-anda/dc${props}`,
    {
      headers
    }
  );
};


export default DebitCardAPI;
